import React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import styleFile from './MonoHotelAvail.js';
import SearchOptions from '../../components/functional/SearchOptions';
import WebAdvantagesWidget from '../../components/functional/WebAdvantageWidget/';
import { Loading } from '@synergycms_core/components/functional/Loading';
import { AvailAccordion } from '../../components/functional/AvailMono/AvailAccordion';
import { MonoHotelAvailSummary } from '../../components/functional/MonoHotelAvailSummary';
import { AvailAlert } from '../../components/functional/AvailAlert';
import LoyaltyUserPoints from '../../components/functional/Loyalty/LoyaltyUserPoints.jsx';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { Map, List } from 'immutable';
import actions from '../../store/actions';
import ButtonCalendar from '../../components/functional/Calendar/ButtonCalendar';
import HotelInfoButton from '../../components/functional/HotelInfoButton/HotelInfoButton';
import { getSegmentsFilled, addScripts } from '../../utils';
import { RichText, Image } from '@synergycms_core/components/generic';
import {FIDELTOUR_CODE, STAR_TRAVELER_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import ModalInfoStarTraveler from '../../components/functional/Loyalty/StarTraveler/ModalInfoStarTraveler';
import CheckBox from '@synergycms_core/components/generic/CheckBox';
import ModalOnSelectRate from '../../components/functional/Loyalty/ModalOnSelectRate';
import { Button } from 'synergycms_core/src/components/generic';
import { getLoyaltyAvailDiscountPercent } from '../../store/avail/availUtils';
import DestinationAvailBtn from '../../components/functional/DestinationAvailBtn';
import { filterAvailServices } from '../../store/avail/availServicesActions';
import moment from 'moment';

const MonoHotelAvail = class MonoHotelAvail extends React.Component {
  static displayName = 'MonoHotelAvail';

  constructor(props) {
    super(props);

    let visibleSegment = 1;
    if (!props.hasSelectionAvail && props.roomRatesSelected.some(value => value.get('price'))) {
      props.resetReservationRequest();
    } else if (props.hasSelectionAvail) {
      let roomRatePending = false;
      props.roomRatesSelected.forEach(value => {
        if (!roomRatePending && value.get('price', false) === false) {
          roomRatePending = value;
        }
      });
      visibleSegment = roomRatePending ? parseInt(roomRatePending.get('idx'), 10) : false;
    }

    const { hotelDetails, referer } = this.props;
    const scripts = hotelDetails.getIn(['extended_scripts'], undefined);
    if (scripts && scripts.size > 0 && referer) {
      addScripts(hotelDetails, referer, 'avail');
    }

    this.state = {
      params: this.props.params,
      visibleSegment: visibleSegment,
      isChecked: props.rateSelected === 'loyalty',
    };
  }

  goBackClick = (forceCity = false) => e => {
    e.preventDefault();
    const { config } = this.props;
    let hotelsCity;
    let hotelsCountry;
    let cityId = false;
    let countryId = false;
    if (config.stepType === 'mono') {
      if (config.city.size > 0 || forceCity) {
        cityId = forceCity ? forceCity : this.props.config.city.get('id');
        hotelsCity = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .filter(h => h.get('city_id') === cityId)
          .toJS()
          .reduce((hotelsCity, hotel) => hotelsCity.concat([hotel.id]), List());
      } else if (config.country.size > 0) {
        countryId = this.props.config.country.get('id');
        hotelsCountry = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .filter(h => h.get('country_id') === countryId)
          .toJS()
          .reduce((hotelsCountry, hotel) => hotelsCountry.concat([hotel.id]), List());
      } else {
        cityId = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .find(h => h.get('id') === config.hotelId)
          .get('city_id');

        hotelsCity = config.hotels
          .getIn(['hotels_info', 'hotels'])
          .filter(h => h.get('city_id') === cityId)
          .toJS()
          .reduce((hotelsCity, hotel) => hotelsCity.concat([hotel.id]), List());
      }
    }
    this.props.goBack(hotelsCity || hotelsCountry, cityId, countryId, config);
  };

  bestAvailPrice = (avail,manual = false) => {
    const showTaxes = this.props.hotelDetails.get("show_taxes");
    let bestPrice = null;
    avail && avail.find(roomTypes => {
      return roomTypes && roomTypes.find(roomType => {
        return roomType && roomType.get('boards').find(board => {
          return board && board.find(refType => {
           if (manual || refType.get('best_price', false) === true) {
              refType.get("days").forEach((day) => {
                const price = day.get(showTaxes ? "price_tax" : "price");
                bestPrice = bestPrice === null || bestPrice > price ? price : bestPrice;
              });
              if(!manual) return true;
           }
           return false;
          });
        });
      });
    });
    return bestPrice;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if(!nextProps.segmentsFilled && prevState.visibleSegment !== 1){
      return { visibleSegment : 1 };
    }
    else return null;
  }

  setVisibleSegment = (segment, isLoyalty) => {
    const { roomsAvail, segmentsFilled } = this.props;
    if (segment === false && roomsAvail.size !== segmentsFilled) {
      segment = segmentsFilled + 1;
    }
    this.setState(
      {
        visibleSegment: segment
      },
      () => {
        const visibleSegment = this.state.visibleSegment || false;
        const ref = this.refs[(isLoyalty && "loyalty")+'accordion' + visibleSegment.toString()];
        if (ref) {
          ref.scrollIntoView();
          window.scrollBy(0, -65);
        } else {
          window.scrollTo(0, 0);
        }
      }
    );
  };

  handleCheckboxChange = (event) => {
    const isChecked = !this.state.isChecked //!event.target.checked;
    this.setState(
      { isChecked },
      () => {
        this.props.resetReservationRequest();
          this.props.getAvail(isChecked ? 'loyalty' : 'standard')
      }
    );
  };

  handleModalCloseCheckboxChange = (value) => {
    if(this.state.isChecked) {
      this.setState({ isChecked: value });
      this.handleCheckboxChange();
    }
  }

  handleShowTabs = (tab) => () => {
    this.setState({ isChecked: tab === 1 });
  };

  componentDidMount() {
    this.props.triggerEvent();
  }

  render() {
    const {
      maxNights,
      roomsAvail,
      loyaltyRoomsAvail,
      isAlterSearch,
      stayLength,
      segmentsFilled,
      roomRatesSelected,
      theme,
      hotelDetails,
      minNightsError,
      langCode,
      webType,
      currentStep,
      loyaltyUser,
      loyalty,
      advantages,
      starTravelerTiers,
      loyaltyDiscount,
      rateSelected,
      cities,
      hotels,
      hotelId,
      destinationHasAvailability,
      hasSelectionAvail,
    } = this.props;

    const {
      isChecked,
    } = this.state;



    const loyaltyBestPrice =this.bestAvailPrice(loyaltyRoomsAvail,hasSelectionAvail);
    const standardRateBestPrice =this.bestAvailPrice(roomsAvail,hasSelectionAvail);

    const type = loyalty && loyalty.get("code");
    const { classes } = theme.styles;
    const boards = roomsAvail && roomsAvail.get(0) && roomsAvail.getIn([0, roomsAvail.get(0).keySeq().first(), 'boards']);
    const finalPrice = boards && boards.getIn([boards.keySeq().first(), 'any', hotelDetails.get('show_taxes') ? 'price_tax' : 'price']);
    const hotelCity = cities.find(city => city.get('id') === hotels.getIn([hotelId, 'city_id']));
    let alertReason = 'no_avail';
    let alertObjVars = {};
    let urlHotel = hotelDetails.getIn(['slug'], ['website'], ['']);
    if (
      (rateSelected === 'loyalty' && !(loyaltyRoomsAvail.get('success') !== false)) ||
      (rateSelected === 'standard' && !(roomsAvail.get('success') !== false))
    ) {
      if (stayLength >= maxNights) {
        alertReason = 'max_nights';
      } else if (minNightsError !== false) {
        alertReason = 'min_nights';
        alertObjVars = {
          value: minNightsError
        };
      }
    }

    const hasLoyaltyAvail = !!loyalty && this.props.loyaltyRoomsAvail.get('success') !== false;
    const enableLoyaltyTab = hasLoyaltyAvail && (loyaltyBestPrice !== 0 && standardRateBestPrice !== loyaltyBestPrice);
    const forceLoyaltyTab = hasLoyaltyAvail && ((this.state.isChecked && enableLoyaltyTab) || loyaltyUser);

    const determineCheckboxId = () => {
      if (type === STAR_TRAVELER_CODE) {
        return forceLoyaltyTab
          ? 'td-d1-startraveler-check-00'
          : 'td-d1-startraveler-check-01';
      }

      return null;
    };

    const listAvail = (avail, isLoyaltyAvail = false, showTabs, enableLoyaltyTab = false) => {
      return (
        <ul className={classes.listContainer}>
          {avail.map((segmentAvail, key) => {
            return (
              <li key={(isLoyaltyAvail && "loyalty") + key} className={classes.roomList}
                  ref={(isLoyaltyAvail && "loyalty") + 'accordion' + (key + 1).toString()}>
                    <AvailAccordion
                      hasLoyaltyAvail={enableLoyaltyTab}
                      setVisibleSegment={this.setVisibleSegment}
                      visibleSegment={key + 1 === this.state.visibleSegment}
                      segmentAvail={segmentAvail}
                      totalSegments={avail.size}
                      segment={key + 1}
                      isLoyaltyAvail={isLoyaltyAvail}
                      enableLoyaltyTab={enableLoyaltyTab}
                      showTabs={showTabs}
                    />
              </li>
            );
          })}
        </ul>
      )
    };

    const LOYALTY_TYPES = {
      STAR_TRAVELER: {
        code: STAR_TRAVELER_CODE,
        url: "https://www.eurostarshotels.com",
        logo: 'stDefaultLogo'
      },
      FIDELTOUR: {
        code: FIDELTOUR_CODE,
        url: "https://www.fideltour.com",
        logo: 'memberOnlyBlue'
      }
    };

    const getLoyaltyType = (type) => {
      return Object.values(LOYALTY_TYPES).find(loyalty => loyalty.code === type);
    };

    const getTextValue = () => {
      if (type === STAR_TRAVELER_CODE) {
        return forceLoyaltyTab
          ? '_%10% dto. miembros activo%_'
          : '_%10% dto. miembros desactivado%_'
      } else if (type === FIDELTOUR_CODE) {
        return forceLoyaltyTab
          ? '_%tarifas para miembros%_'
          : '_%ver tarifas para miembros%_';
      }

      return null;
    }

    const renderLoyaltyButton = (type) => {
      const loyaltyType = getLoyaltyType(type);
      const programLogo = type === STAR_TRAVELER_CODE ? loyaltyType.logo+'Hz': loyaltyType.logo;
      if(!loyaltyUser) {
        if (loyaltyType) {
          return (
            <div
              className={classes.buttonLogo}
              //id={type === STAR_TRAVELER_CODE ? 'td-d1-startraveler-modal-00' : undefined}
            >
              {type === STAR_TRAVELER_CODE &&
              <ModalInfoStarTraveler
                id={'td-d1-startraveler-modal-00'}
                advantages={advantages}
                starTravelerTiers={starTravelerTiers}
                buttonContent={() => <span><Image innerStyle={classes.starTravelerTabLogo} svg={programLogo} /></span>}
              />
              }
              {type === FIDELTOUR_CODE &&
              <Image innerStyle={classes.starTravelerTabLogo} svg={programLogo}/>
              }
            </div>
          );
        }
      }
      return null;
    };

    const renderLoyaltyTab = () => {
      if (!loyaltyUser && loyaltyDiscount) {
        return (
          <div className={type === STAR_TRAVELER_CODE ? classes.containerRateStarTraveler : classes.containerRateFidelTour}>
            <div className={classes.rateBox}>
              {renderLoyaltyButton(type)}
              <div className={classes.toggleCheck}>
                <div className={classes.loyaltyText}>
                  <RichText
                    translate={true}
                    text={getTextValue()}
                    ucFirst={true}
                    dangerouslySetInnerHTML={true}
                  />

                  {type === FIDELTOUR_CODE &&
                    <ModalOnSelectRate isLoyaltyAvail={true} closeCallback={this.handleModalCloseCheckboxChange}>
                      <Button
                        id="td-d1-confirm-price-01"
                        richText={
                          theme.width >= 902 && {
                            ucFirst: true,
                            text: '_%¿Ya eres miembro? Haz Click Aquí%_',
                            innerStyle: classes.loyaltyLoginButton,
                            translate: true
                          }
                        }>
                      </Button>
                    </ModalOnSelectRate>
                  }
                </div>

                {/*type === FIDELTOUR_CODE &&
                <div className={classes.toolTipFideltour}>
                  <TooltipWrapper
                    popover=
                      {<span className={[classes.ratePopover]}>
                          <RichText
                            translate={true}
                            text={'_%texto tooltip programa fideltour%_'}
                            ucFirst={true}
                            innerStyle={[]}
                            dangerouslySetInnerHTML={true}
                          />
                        </span>}
                    popoverStyle={classes.rateTooltip}
                    bottomLimit={100}
                    pointerStyle={classes.tooltipPointerStyle}
                    posX={'middle'}
                    posY={'top'}>
                    <Image unicodeContent="e143" innerStyle={['gold']}/>
                  </TooltipWrapper>
                </div>
                */}

              <label
                className={`${classes.switch} ${loyaltyUser ? classes.disabled : ''} ${type === FIDELTOUR_CODE ? classes.widthFideltour : ''}`}>
                {/*<input
                  type="checkbox"
                  id={determineCheckboxId()}
                  className={classes.switchInput}
                  checked={forceLoyaltyTab ? this.setState.isChecked = true : this.setState.isChecked = false }
                  onChange={this.handleCheckboxChange}
                  />
                  <span className={`${classes.slider} ${classes.sliderRound}`} />*/}

                  <CheckBox
                    onChange={this.handleCheckboxChange}
                    innerStyle={`${classes.slider} ${classes.sliderRound} ${isChecked ? '' : classes.nocheck}`}
                    id={determineCheckboxId()}
                    tabIndex={-1}
                  />
                </label>
              </div>
            </div>
          </div>
        );
      }
      return null;
    };

    const renderAvailList = () => {
      if (forceLoyaltyTab && loyaltyRoomsAvail) {
        if(!loyaltyDiscount) return listAvail(loyaltyRoomsAvail, false, this.handleShowTabs, false)
        else return listAvail(loyaltyRoomsAvail, forceLoyaltyTab, this.handleShowTabs, enableLoyaltyTab)
      }
      if(roomsAvail.get('success') !== false) {
        return listAvail(roomsAvail, forceLoyaltyTab, this.handleShowTabs, enableLoyaltyTab)
      }
      return null;
    };


    if (roomsAvail.get('success') !== false || loyaltyRoomsAvail.get('success') !== false) {
      return (
        <div className={classes.defaultStyle}>
          <LoyaltyUserPoints />
          <SearchOptions innerStyle={['monoHotelSearchOptions']} />
          {isAlterSearch && <AvailAlert type={'alter_avail'} />}
          <div>
            {this.props.theme.deviceType !== 'DESK' && (
              <div className={`${classes.calendarInfoButton} ${webType === 'WI' ? classes.wiCalendarInfoButton : ''}`}>
                <ButtonCalendar webType={webType} />
                {destinationHasAvailability && <div className={classes.destinationAvailBox}>
                  <DestinationAvailBtn
                    id={'td-d1-destination-subh-00'}
                    hotelCity={hotelCity}
                    goBack={this.goBackClick(hotelCity.get('id', false))}
                    deviceType={this.props.theme.deviceType}
                  />
                </div>
                }
                {currentStep === 'monoHotelAvail' && webType !== 'WI' && (
                  <div className={classes.seeHotelWeb}>
                    <HotelInfoButton langCode={langCode} urlHotel={urlHotel} deviceType={this.props.theme.deviceType} />
                  </div>
                )}
              </div>
            )}

            {enableLoyaltyTab && renderLoyaltyTab()}

            {renderAvailList()}
          </div>

          <MonoHotelAvailSummary
            totalSegments={rateSelected === 'loyalty' ? loyaltyRoomsAvail.size : roomsAvail.size}
            segmentsFilled={segmentsFilled}
            roomRatesSelected={roomRatesSelected}
          />
          {false && this.props.theme.deviceType === 'DESK' && (
            <WebAdvantagesWidget price={finalPrice} webAdvantages={hotelDetails.get('web_advantages', List())} />
          )}
        </div>
      );
    }

    return (
      <div className={classes.defaultStyle}>
        <SearchOptions innerStyle={['monoHotelSearchOptions']}/>
        <div>
          <AvailAlert type={alertReason} objVars={alertObjVars}/>
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {
    getAvail: (rate) => {
      dispatch(actions.customer.rateSelected.set(rate))
      dispatch(actions.avail.getAvailAsync()).then(() => dispatch(actions.avail.getAvailParsed()))
    },
    resetReservationRequest: () => {
      dispatch(actions.customer.roomPreferences.initialize());
      dispatch(actions.customer.reservation.set(Map()));
      dispatch(actions.customer.reservationRequest.initialize());
    },
    triggerEvent: () => {
      dispatch(actions.events.trigger('show_avail'));
    },
    goBack: (totalSegments, availServices, reservationBlocks, group) => (hotelsIds, cityId, countryId, config) => {
      const currentStep = config.currentStep;
      if (currentStep === 'monoHotelAvail') {
        dispatch(actions.customer.currentHotel.clear());
        if (cityId) {
          dispatch(actions.customer.params.updateParams(Map({ hotelId: null, hotels: hotelsIds, city_id: cityId })));
        } else if (countryId) {
          dispatch(actions.customer.params.updateParams(Map({ hotelId: null, hotels: hotelsIds, country_id: countryId })));
        }
        dispatch(actions.customer.currentHotels.set(hotelsIds));
        dispatch(actions.customer.step.prev());
        dispatch(actions.router.update());
        dispatch(actions.availServices.getAsync());

        return Promise.all([
          dispatch(actions.hotels.getAsync()),
          dispatch(actions.customer.loyalty.getDescriptiveAsync(group))
            .then((result)=> {
              return result.get(group, null) ? dispatch(actions.avail.getLoyaltyAvailAsync(group)) : dispatch(actions.avail.getAsync());
            })
        ]).then(() => {
          dispatch(actions.customer.orderBy.set(group === 'eurostarshotels' ? 'proximity' : 'price'));
          dispatch(actions.customer.filters.get());
        })
          .tap(dispatch(actions.events.trigger('show_avail')));
      } else {
        if (
          currentStep === 'customerForm' &&
          !filterAvailServices(availServices.get('services'), reservationBlocks).size
        ) {
          dispatch(actions.customer.step.change('monoHotelAvail'));
        } else {
          dispatch(actions.customer.step.prev());
        }
        dispatch(actions.router.update());
      }
    },
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const params = store.getIn(['customer', 'params', 'params'], undefined);
  const rateSelected = store.getIn(['customer', 'rate_selected']);

  var roomsAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'string_query_params']),
    'response'
  ]);

  var loyaltyRoomsAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'string_loyalty_query_params']),
    'response'
  ]);

  /***** FILTER AVAIL ******/
  const selectionAvail = store.getIn(['customer', 'params', 'params', 'selection_avail'], null);
  
  if(rateSelected === 'loyalty' && !loyaltyRoomsAvail && !roomsAvail) {
    loyaltyRoomsAvail = Map({success: false});
    roomsAvail = Map({success: false});
  }
  if(rateSelected === 'standard' && !loyaltyRoomsAvail) loyaltyRoomsAvail = Map({success: false});

  const alterSearch = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', rateSelected === 'loyalty' ? 'string_loyalty_query_params' : 'string_query_params']),
    'is_alter_search'
  ]);

  const baseAlterSearch = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', rateSelected === 'loyalty' ? 'base_string_loyalty_query_params' : 'base_string_query_params']),
    'is_alter_search'
  ]);

  const isAlterSearch = alterSearch && baseAlterSearch;

  const roomRatesSelected = store.getIn(['customer', 'reservation_request', 'blocks'], List());
  const segmentsFilled = roomRatesSelected.size > 0 ? getSegmentsFilled(roomRatesSelected) : 0;
  const isSelectionCompleted = !selectionAvail || segmentsFilled > 0;
  const currentStep = store.getIn(['customer', 'step', 'current_step', 'code'], null);
  const webType = store.getIn(['customer', 'web_type'], false);
  const minNightsError =
    store.getIn([
      'avail',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', rateSelected === 'loyalty' ? 'string_loyalty_query_params' : 'string_query_params']),
      'raw_response',
      0,
      'code'
    ], false) === 362 &&
    store.getIn([
      'avail',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', rateSelected === 'loyalty' ? 'string_loyalty_query_params' : 'string_query_params']),
      'raw_response',
      0,
      'error_param'
    ], false);
  const loyalty = store.getIn(['customer', 'loyalty', 'data', 'loyalty'], null);
  const advantages = store.getIn(['customer', 'loyalty', 'data', 'advantages'], null);
  const starTravelerTiers = store.getIn(['customer', 'loyalty', 'data', 'tiers'], null);


  let loyaltyDiscount = getLoyaltyAvailDiscountPercent(store);

  const hotelGroup = store.getIn(['hotels', hotelId, 'group']);

  const availCacheQueryParams = store.getIn(['customer', 'params', 'avail_cache_query_params'], Map());

  const availCache = store.getIn(['availCache', hotelGroup, availCacheQueryParams], false);

  let city = Map();
  let country = Map();

  const startDate = store.getIn(['customer', 'params', 'url_params', 'start'], false);
  const endDate = store.getIn(['customer', 'params', 'url_params', 'end'], false);

  const getDateRange = (start, end) => {
    const range = [];
    if(start && end ){
      let currentDate = moment(start);
      const finalDate = moment(end);

      while (currentDate.isSameOrBefore(finalDate, 'day')) {
        range.push(currentDate.format('YYYY-MM-DD'));
        currentDate.add(1, 'day');
      }
    }
    return range;
  };

  const dateRange = getDateRange(startDate, endDate);

  let destinationHasAvailability = false;

  if(webType === 'PORTAL') {
    country =
      params &&
      params.get('country_id') &&
      store.getIn(['hotels', 'hotels_info', 'countries']).find(country => {
        return country.get('id') === parseInt(params.get('country_id'), 10);
      });

    city =
      params &&
      params.get('city_id') &&
      store.getIn(['hotels', 'hotels_info', 'cities']).find(city => {
        return city.get('id') === parseInt(params.get('city_id'), 10);
      });

    if (availCache) {
      destinationHasAvailability = true;
      dateRange.forEach((date) => {
        if (availCache.getIn([date, 'count'], 0) < 2) {
          destinationHasAvailability = false;
          return;
        }
      });
    }
  }

  return {
    params: store.getIn(['customer', 'params', 'params']),
    resolveAvail:
      store.getIn(['customer', 'params', 'query_params']) ===
        store.getIn(['hotels', hotelId, 'params', 'base_string_query_params'])
        ? true
        : undefined,
    roomRatesSelected: roomRatesSelected,
    maxNights: store.getIn(['hotels', hotelId, 'max_avail']) || 31,
    hotelInfo: store.getIn(['hotels', hotelId, 'success']),
    roomsAvail: rateSelected === 'standard' && roomsAvail?.get('success') === false && loyaltyRoomsAvail?.get('success') === undefined ? undefined : roomsAvail,
    loyaltyRoomsAvail: loyaltyRoomsAvail,
    hotelDetails: store.getIn(['hotels', hotelId], undefined),
    isAlterSearch: isAlterSearch,
    minNightsError: minNightsError,
    blocks: store.getIn(['customer', 'reservation_request', 'blocks']),
    stayLength: store.getIn(['customer', 'params', 'params', 'stay_length']),
    referer: store.getIn(['customer', 'params', 'url_params', 'id_referer'], false),
    segmentsFilled: segmentsFilled,
    hasSelectionAvail: selectionAvail,
    isSelectionCompleted: isSelectionCompleted,
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    currentStep: currentStep,
    webType: webType,
    loyalty: loyalty,
    loyaltyUser: store.getIn(['customer', 'loyalty','user'], null),
    loyaltyType: loyalty && loyalty.get("code", null),
    advantages: advantages,
    starTravelerTiers: starTravelerTiers,
    rateSelected: rateSelected,
    loyaltyDiscount: loyaltyDiscount,
    cities: store.getIn(['hotels', 'hotels_info', 'cities'], List()),
    hotels: store.getIn(['hotels']),
    hotelId: hotelId,
    destinationHasAvailability: destinationHasAvailability,
    config: {
      stepType: store.getIn(['customer', 'step', 'current_step', 'type'], null),
      city: city,
      country: country,
      hotels: store.getIn(['hotels']),
      hotelId: hotelId,
      currentStep: currentStep,
    },
    group: store.get("group", false),
    availServices: store.getIn(['availServices']),
    reservationBlocks: store.getIn(['customer', 'reservation_request', 'blocks'])
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  goBack: dispatchProps.goBack(stateProps.totalSegments, stateProps.availServices, stateProps.reservationBlocks, stateProps.group)
});

const fragment = props => {

  const engineSygyData = window.frontLoader || window.engine_sygy_data;
  const { webType } = props;
  const group = engineSygyData && engineSygyData.group;
  const corporateLogin = window.LoginUser && +window.LoginUser.tipo_perfil === 1 ? window.LoginUser : null;
  const loyaltyLogin = window.LoginUser && +window.LoginUser.tipo_perfil === 2 ? window.LoginUser : null;
  const userLogIn = (corporateLogin && corporateLogin.usuario !== 'NoLogin') || (loyaltyLogin && loyaltyLogin.usuario !== 'NoLogin');

  return (
  <React.Fragment>
    <Loading
      richText={{
        ucFirst: true,
        innerStyle: ['descriptionText'],
        text: '_%estamos buscando los mejores precios para ti%_',
        translate: true
      }}
        showLoyaltyBanner={webType === 'PORTAL' && group === 'eurostarshotels' && !userLogIn}
    />
  </React.Fragment>
);
};

export default compose(
  validateAsyncComponent(mapStateToProps, [], fragment),
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  withThemeJSS({ styleFile, index: 100, link: true})
)(MonoHotelAvail);
